import React from "react";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Coupons from "./components/Pages/Coupons/Coupons";
import Contact from "./components/Pages/Contact/Contact";
import Help from "./components/Pages/Help/Help";
import Settings from "./components/Pages/Settings/Settings";
import Login from "./components/Pages/Login/Login";
import Collections from "./components/Pages/Collections/Collections";
import CreditPackage from "./components/Pages/CreditPackage/CreditPackage";
import StoragePlan from "./components/Pages/Storage/Storage";
import Extensions from "./components/Pages/Extensions/Extensions";
import AIStudioManager from "./components/Pages/AIStudioManager/AIStudioManager";
import PlanControl from "./components/Pages/PlanControl/PlanControl";

const PageRouter = (data) => {
  return (
    <Router>
      <Switch>
        <Route
          exact
          path="/"
          render={(props) => <Login {...data} {...props} />}
        />
        <Route
          path="/login"
          render={(props) => <Login {...data} {...props} />}
        />
        <Route
          path="/coupons"
          render={(props) => <Coupons {...data} {...props} />}
        />
        <Route
          path="/contact"
          render={(props) => <Contact {...data} {...props} />}
        />
        <Route path="/help" render={(props) => <Help {...data} {...props} />} />
        <Route
          path="/settings"
          render={(props) => <Settings {...data} {...props} />}
        />
        <Route
          path="/collections"
          render={(props) => <Collections {...data} {...props} />}
        />
        <Route
          path="/credit-package"
          render={(props) => <CreditPackage {...data} {...props} />}
        />
        <Route
          path="/storage"
          render={(props) => <StoragePlan {...data} {...props} />}
        />
        <Route
          path="/extensions"
          render={(props) => <Extensions {...data} {...props} />}
        />
        <Route
          path="/ai-studio"
          render={(props) => <AIStudioManager {...data} {...props} />}
        />
        <Route
          path="/PlanControl"
          render={(props) => <PlanControl {...data} {...props} />}
        />
      </Switch>
    </Router>
  );
};

export default PageRouter;
